/* eslint-disable filename-export/match-default-export */

import React, { useState } from 'react';
import pt from 'prop-types';

import AceDiffPane from './AceDiffPane';
import useAceDiff from './useAceDiff';

import s from './ace-diff-viewer.module.scss';

const DEFAULT_HEIGHT = '600px';

export default function AceDiffViewer({
  oldValue,
  newValue,
  lang,
  leftTitle,
  rightTitle,
  height = DEFAULT_HEIGHT,
  name = 'aceDiffViewer',
  collapseUnchanged = true,
  foldable = false,
}) {
  const [leftEditor, setLeftEditor] = useState(null);
  const [rightEditor, setRightEditor] = useState(null);

  useAceDiff({ leftEditor, rightEditor, oldValue, newValue, collapseUnchanged, foldable });

  return (
    <div className={s.diffViewer}>
      {(leftTitle || rightTitle) && (
        <div className={s.titleRow}>
          <div className={s.title}>{leftTitle}</div>
          <div className={s.title}>{rightTitle}</div>
        </div>
      )}
      <div className={s.paneRow}>
        <div className={s.pane}>
          <AceDiffPane
            name={`${name}-left`}
            lang={lang}
            value={oldValue}
            height={height}
            foldable={foldable}
            onEditorLoad={setLeftEditor}
          />
        </div>
        <div className={s.pane}>
          <AceDiffPane
            name={`${name}-right`}
            lang={lang}
            value={newValue}
            height={height}
            foldable={foldable}
            onEditorLoad={setRightEditor}
          />
        </div>
      </div>
    </div>
  );
}

AceDiffViewer.propTypes = {
  oldValue: pt.string.isRequired,
  newValue: pt.string.isRequired,
  lang: pt.oneOf(['json', 'lua', 'yaml']).isRequired,
  leftTitle: pt.node,
  rightTitle: pt.node,
  height: pt.string,
  name: pt.string,
  collapseUnchanged: pt.bool,
  foldable: pt.bool,
};
